import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "./firebase";

export async function uploadTapeMainPhoto(ownerUserId, tapeId, file) {
  const path = `users/${ownerUserId}/tapes/${tapeId}/main.jpg`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}

export async function uploadTapeAdditionalPhoto(ownerUserId, tapeId, file) {
  const imageId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `users/${ownerUserId}/tapes/${tapeId}/additional/${imageId}.jpg`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}

export async function uploadPlayerListingPhoto(ownerUserId, listingId, file) {
  const imageId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `users/${ownerUserId}/playerListings/${listingId}/${imageId}.jpg`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}

export async function uploadRepairListingPhoto(ownerUserId, listingId, file) {
  const imageId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `users/${ownerUserId}/repairListings/${listingId}/${imageId}.jpg`;
  const fileRef = ref(storage, path);
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}

export async function deletePhotoByUrl(url) {
  try {
    await deleteObject(ref(storage, url));
  } catch (e) {
    // If the file is already gone or the URL can't be resolved to a ref, there's
    // nothing more to clean up — the Firestore reference removal is what matters.
  }
}
